import { useTranslation } from "react-i18next";
import { openHostOffers, useHostOfferInbox } from "./incomingHostOffers";
import Chip from "../../../ui/feedback/Chip";

/** The number of host offers waiting for the user, on the Threads tab (Q-60). */
export default function HostOfferBadge() {
  const { t } = useTranslation();
  const count = openHostOffers(useHostOfferInbox()).length;
  if (count === 0) {
    return null;
  }
  return (
    <Chip tone="info" size="compact" title={t("threads.inbox.badge", { count })} className="ml-1.5 font-semibold">
      {count}
      <span className="sr-only">{t("threads.inbox.badge", { count })}</span>
    </Chip>
  );
}
